import React, { useState, Fragment } from 'react'
import { Dialog, Transition, Listbox } from '@headlessui/react'
import { IoClose } from 'react-icons/io5'
import { BiRightArrowAlt } from 'react-icons/bi'
import { HiChevronUpDown } from 'react-icons/hi2'

const Taxrate = [
    { id: 1, name: 'Select a tax rate' },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const DefaultTaxModal = ({ open, setOpen }) => {
    const [taxrate, setTaxrate] = useState(Taxrate[0])
    return (
        <div>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c0c8d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-md">
                                    <div>
                                        <div className="font-semibold p-[16px_20px] text-base text-gray-900 border-b-[1px] border-[#ebeef1]">Add default tax</div>
                                        <div className="p-[16px_20px] border-b-[1px] border-[#ebeef1]">
                                            <div className='flex gap-4 mt-2 w-full'>
                                                <Listbox value={taxrate} onChange={setTaxrate}>
                                                    {({ open }) => (
                                                        <>
                                                            <div className="relative w-full">
                                                                <Listbox.Button className="relative w-full rounded-md bg-white h-[30px] py-[2px] pl-3 pr-10 text-left text-gray-900 shadow-sm font-semibold ring-1 ring-inset ring-gray-300 focus:outline-none text-sm sm:leading-6">
                                                                    <span className="block truncate">{taxrate.name}</span>
                                                                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-1">
                                                                        <HiChevronUpDown className='text-[20px]' />
                                                                    </span>
                                                                </Listbox.Button>

                                                                <Transition
                                                                    show={open}
                                                                    as={Fragment}
                                                                    leave="transition ease-in duration-100"
                                                                    leaveFrom="opacity-100"
                                                                    leaveTo="opacity-0"
                                                                >
                                                                    <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 shadow-xl focus:outline-none text-sm">
                                                                        {Taxrate.map((person) => (
                                                                            <>
                                                                                <Listbox.Option
                                                                                    key={person.id}
                                                                                    className={({ active }) =>
                                                                                        classNames(
                                                                                            active ? 'bg-[#f6f8fa]' : 'text-[#414552]',
                                                                                            'relative cursor-default select-none py-[6px] pl-3 pr-5'
                                                                                        )
                                                                                    }
                                                                                    value={person}>
                                                                                    {({ taxrate, active }) => (
                                                                                        <>
                                                                                            <span className={classNames(taxrate ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                                                                {person.name}
                                                                                            </span>

                                                                                            {taxrate ? (
                                                                                                <span
                                                                                                    className={classNames(
                                                                                                        active ? 'text-white' : 'text-indigo-600',
                                                                                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                                                                                    )}
                                                                                                >
                                                                                                </span>
                                                                                            ) : null}
                                                                                        </>
                                                                                    )}
                                                                                </Listbox.Option>
                                                                                <div className='text-sm flex items-center gap-1 text-[#414552] border-t-[1px] border-[#ebeef1] relative cursor-default select-none py-[6px] pl-3 pr-5'>
                                                                                    <span>No tax rates found. Create a</span>
                                                                                    <button className='flex items-center gap-1 text-[#625afa] font-semibold'>new tax rate<BiRightArrowAlt className='text-[18px]' /></button>
                                                                                </div>
                                                                            </>
                                                                        ))}
                                                                    </Listbox.Options>
                                                                </Transition>
                                                            </div>
                                                        </>
                                                    )}
                                                </Listbox>
                                                <button><IoClose className='text-gray-500' /></button>
                                            </div>
                                            <button className='text-[#687385] font-semibold mt-3 text-sm'>Add another tax</button>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                                            <button className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px]" onClick={() => setOpen(false)}>Cancel</button>
                                            <button className="h-[30px] rounded-[6px] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Add tax</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default DefaultTaxModal